import { Constants } from "appConstants";
import { IcoArrowLeft, IcoEdit } from "assets/icons";
import { Button } from "components";
import { useNavigate } from "react-router-dom";
import "./styles.scss";

interface HeadingDetailsProps {
	title: string;
	showEditButton?: boolean;
	navigationReturn?: any;
}

export default function HeadingDetails(props: Readonly<HeadingDetailsProps>) {
	const { title, showEditButton = true, navigationReturn = -1 } = props;
	const navigate = useNavigate();

	return (
		<div className="heading-details">
			<div className="heading-details-controls">
				<Button
					styled="ghost"
					kind="link"
					size="small"
					onClick={() => navigate(navigationReturn)}
				>
					<IcoArrowLeft size="20" />
				</Button>
				<span className="font-heading-semibold-tiny">{title}</span>
			</div>
			{showEditButton && (
				<Button styled="ghost-2" size="small" onClick={() => navigate("edit")}>
					<IcoEdit />
					{Constants.strings.inputs.edit}
				</Button>
			)}
		</div>
	);
}
